// read about Object.prototype.toString.call at https://toddmotto.com/understanding-javascript-types-and-reliable-type-checking/#true-object-types
import axios from 'axios';
import axios2 from 'axios';
import axiosRetry from 'axios-retry';

const baseURL = process.env.google_functions_url || 'https://us-central1-contracts-demo-firestore.cloudfunctions.net';

function addHeaders() {
    if ( typeof document !== 'undefined' ) {
        const sessionId = localStorage.getItem( 'sessionId' );
        if ( typeof sessionId !== 'undefined' ) {
            return {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Basic ${sessionId}`
            };
        }
    }
    return {
    // Accept: "application/json",
    // "Content-Type": "application/json"
    };
}

function requestHeaders( extraHeaders ) {
    return Object.assign(
        { },
        addHeaders(),
        extraHeaders
    );
}

export default ( url, method, extraHeaders, body ) => {
    const details = {
        baseURL,
        method,
        url,
        data: body,
        headers: requestHeaders( extraHeaders ),
        responseType: 'json' // options are 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream',
    };
    return axios( details );
};

axiosRetry( axios2, { retries: 3,
    retryDelay: ( retryCount ) => retryCount * 2000 } );
export const baseAxios = () => axios2;
